import { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "../../Home/Components/TechComp.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-bootstrap-icons/dist/icons/0-circle-fill";
import "react-datepicker/dist/react-datepicker.css";
import about from '../../assets/service/Image for Landing Page -BG (15).webp';
import iconManage from "../../assets/service/iconManage.png";
import iconAnalytics from "../../assets/service/iconAnalytics.png";
import iconSupport from "../../assets/service/iconSupport.png";
import {
    FaUser,
    FaPhoneAlt,
    FaEnvelope,
    FaCommentDots,
    FaBuilding,
    FaMapMarkerAlt,
    FaCheck
} from "react-icons/fa";

import "./DemoModal.css";




const BookDemoModal = ({ showDemo, handleDemoClose }) => {
    // ✅ FORM STATE (TOP LEVEL — REQUIRED)
    const [formData, setFormData] = useState({
        phone: "",
        country: "in",
        name: "",
        company: "",
        email: "",
        requirement: "",
        city: "",
        businessType: "",
        usersCount: "",
        captchaInput: "",
    });
    const closeDemoModal = () => {
        handleDemoClose(); // parent controls visibility

        setFormData({
            phone: "",
            country: "in",
            name: "",
            company: "",
            email: "",
            requirement: "",
            city: "",
            businessType: "",
            usersCount: "",
            captchaInput: "",
        });

        setErrors({});
        setCaptchaTexts(generateCaptcha());
    };
    const validateField = (field, value) => {
        let error = "";

        const nameRegex = /^[A-Za-z _-]+$/;
        const cityRegex = /^[A-Za-z _-]*$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        const phoneRegex = /^[0-9]{12}$/;

        function validateInput(value, regex) {
            // Remove leading/trailing spaces before validation
            const trimmedValue = value.trim();
            if (!regex.test(trimmedValue)) {
                return "Invalid input";
            }
            return "";
        }
        switch (field) {
            case "name":
                if (!value.trim()) error = "Name is required";
                else if (!nameRegex.test(value))
                    error = "Only AlphaNumerics are allowed.";
                else if (value.length > 50)
                    error = "Maximum 50 characters allowed.";
                break;
            case "company":
                if (!value.trim()) error = "Company is required";
                else if (!nameRegex.test(value))
                    error = "Only AlphaNumerics are allowed";
                else if (value.length > 50)
                    error = "Maximum 50 characters allowed.";
                break;
            case "city":
                if (value && !cityRegex.test(value))
                    error = "Only AlphaNumerics are allowed";
                else if (value.length > 50)
                    error = "City cannot exceed 50 characters";
                break;

            /* ---------- EMAIL ---------- */
            case "email":
                if (!value.trim()) error = "Email is required";
                else if (!emailRegex.test(value))
                    error = "Enter Valid Email";
                break;

            /* ---------- PHONE ---------- */
            case "phone":
                if (!value) error = "Phone number is required";
                else {
                    const digits = value.replace(/\D/g, "");
                    if (!phoneRegex.test(digits))
                        error = "Enter valid 10-digit mobile number";
                }
                break;

            /* ---------- REQUIREMENT ---------- */
            case "requirement":
                if (!value.trim()) error = "Requirement is required";
                else if (value.length > 500)
                    error = "Requirement cannot exceed 500 characters";
                break;


            /* ---------- CAPTCHA ---------- */
            case "captchaInput":
                if (!value.trim()) error = "Enter CAPTCHA";
                else if (value.toUpperCase() !== captchaTexts)
                    error = "CAPTCHA does not match";
                break;

            default:
                break;
        }

        return error;
    };

    const validateForm = () => {
        const newErrors = {};

        Object.keys(formData).forEach((field) => {
            const error = validateField(field, formData[field]);
            if (error) newErrors[field] = error;
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const [showDemoThankYou, setShowDemoThankYou] = useState(false);
    const handleSubmitOfDemo = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            const response = await fetch("https://formspree.io/f/xykzrwjb", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name: formData.name,
                    contactNumber: formData.phone,
                    email: formData.email,
                    requirements: formData.requirement,
                    company: formData.company,
                    city: formData.city,
                    businessType: formData.businessType,
                    usersCount: formData.usersCount,
                }),
            });

            if (!response.ok) throw new Error("Form submission failed");

            setFormData({
                phone: "",
                country: "in",
                name: "",
                company: "",
                email: "",
                requirement: "",
                city: "",
                businessType: "",
                usersCount: "",
                captchaInput: "",
            });

            setCaptchaTexts(generateCaptcha());
            setErrors({});

            setShowDemoThankYou(true);

            fireThankYouTracking();

        } catch (error) {
            console.error("Error submitting demo form:", error);
        }
    };

    const fireThankYouTracking = () => {
        if (window.gtagAlreadyFired) return;

        const script = document.createElement("script");
        script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11319131363";
        script.async = true;
        document.body.appendChild(script);

        const configScript = document.createElement("script");
        configScript.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-11319131363');
        `;
        document.body.appendChild(configScript);

        const conversionScript = document.createElement("script");
        conversionScript.innerHTML = `
          gtag('event', 'conversion', {
            'send_to': 'AW-11319131363/g6SyCO_lsbIZEOP5sJUq',
            'value': 1.0,
            'currency': 'INR'
          });
        `;
        document.body.appendChild(conversionScript);

        window.gtagAlreadyFired = true;

        const waitForClarity = () => {
            if (typeof window.clarity === "function") {
                window.clarity("track", "ThankYouPageVisited");
            } else {
                setTimeout(waitForClarity, 100);
            }
        };

        waitForClarity();
    };

    useEffect(() => {
        if (showDemoThankYou) {
            const timer = setTimeout(() => {
                setShowDemoThankYou(false);
                //   handleDemoClose(false);
                closeDemoModal();

            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [showDemoThankYou]);

    const businessTypes = [
        "Manufacturing",
        "Retail",
        "Wholesale",
        "Pharma",
        "Distributor",
        "Supply Chain",
        "Warehouse",
        "Construction",
        "Other"
    ];
    const userCounts = ["Less than 3", "3 - 5", "6 - 10", "More than 10"];

    function generateCaptcha() {
        const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
        let text = "";
        for (let i = 0; i < 6; i++) {
            text += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return text;
    }

    const [errors, setErrors] = useState({});
    const [captchaTexts, setCaptchaTexts] = useState(generateCaptcha());
    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [field]: validateField(field, value),
        }));
    };
    return (
        < Modal
            show={showDemo}
            onHide={closeDemoModal}
            centered
            size="lg"
            backdrop
            keyboard
            dialogClassName="right-slide-modal"
            contentClassName="right-slide-content "
            aria-labelledby="demo-modal-title"
        >
            <Modal.Body className="p-0 demo-modal-body">
                <button
                    className="modal-close-btn"
                    onClick={closeDemoModal}
                >
                    ×
                </button>
                        
                <div className="row g-0 h-100">
                    {/* LEFT PANEL */}
                    <div className="col-md-6 demo-left">
                        {/* Primary section title for the left panel should be below the modal title (h2) */}
                        <h3 className="fw-bold mb-3">TechCognics Cloud-Based Best HRMS Solution</h3>
                        <h4 className="text-muted mb-2">Schedule a One-on-One Demo with</h4>

                        {/* ERP DEVICE IMAGE */}
                        <div className="text-center mb-4">
                            <img
                                src={about}
                                alt="ERP Dashboard Preview"
                                className="img-fluid demo-erp-img"
                            />
                        </div>

                        {/* FEATURES */}
                        <div className="row text-center mt-3">
                            <div className="col-4">
                                <img src={iconManage} className="mb-2 " />
                                <small>End-to-End<br />Business Management</small>
                            </div>

                            <div className="col-4">
                                <img src={iconAnalytics} className="mb-2 " />
                                <small>Smart Analytics<br />& Real-Time Reports</small>
                            </div>

                            <div className="col-4">
                                <img src={iconSupport} className="mb-2 " />
                                <small>Fast Implementation<br />& Expert Support</small>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT PANEL */}
                    <div className="col-md-6 demo-right">
                        {/* Sticky Header — primary modal heading (h2) */}
                        <div className="demo-fixed-header">
                            <h3 id="demo-modal-title" className="fw-semibold text-center m-0">
                                Connect with HRMS Expert Now!
                            </h3>
                        </div>

                        {/* Form or Thank You */}
                        <div className="demo-form-scroll flex-grow-1">
                            {showDemoThankYou ? (
                                <div className="thank-you-wrapper">
                                    <div className="thank-you-pages">
                                        <FaCheck className="icons" />
                                        <h3>Thank you for reaching out!</h3>
                                        <p className="mb-0">One of our experts will get in touch with you shortly.</p>
                                    </div>
                                </div>
                            ) : (
                                <Form onSubmit={handleSubmitOfDemo} id="demoForm">
                                    {/* Phone Input */}
                                    <Form.Group className="mb-2">
                                        <div className={`custom-input-group ${errors.phone ? "is-invalid" : ""}`}>
                                            <span className="custom-input-icon">
                                                <FaPhoneAlt />
                                            </span>
                                            <PhoneInput
                                                country={formData.country}
                                                value={formData.phone}
                                                onChange={(value, country) =>
                                                    handleChange("phone", value, { country: country.countryCode })
                                                }
                                                autoFormat={false}
                                                countryCodeEditable={false}
                                                enableSearch
                                                specialLabel=""
                                                inputProps={{
                                                    name: "phone",
                                                    className: "form-control phone-control",
                                                    placeholder: "Phone",
                                                }}
                                            />



                                        </div>
                                        {errors.phone && (
                                            <div className="invalid-feedback d-block">{errors.phone}</div>
                                        )}
                                    </Form.Group>

                                    {/* Name Input */}
                                    <Form.Group className="mb-2">
                                        <div className={`custom-input-group ${errors.name ? "is-invalid" : ""}`}>
                                            <span className="custom-input-icon">
                                                <FaUser />
                                            </span>
                                            <Form.Control
                                                placeholder="Enter Name"
                                                name="name"
                                                value={formData.name}
                                                onChange={(e) => handleChange("name", e.target.value)}
                                                className="form-control"
                                            />
                                        </div>
                                        {errors.name && (
                                            <div className="invalid-feedback d-block">{errors.name}</div>
                                        )}
                                    </Form.Group>

                                    {/* Company Input */}
                                    <Form.Group className="mb-2">
                                        <div className={`custom-input-group ${errors.company ? "is-invalid" : ""}`}>
                                            <span className="custom-input-icon">
                                                <FaBuilding />
                                            </span>
                                            <Form.Control
                                                placeholder="Company Name"
                                                name="company"
                                                value={formData.company}
                                                onChange={(e) => handleChange("company", e.target.value)}
                                            />
                                        </div>
                                        {errors.company && (
                                            <div className="invalid-feedback d-block">{errors.company}</div>
                                        )}
                                    </Form.Group>

                                    {/* Email Input */}
                                    <Form.Group className="mb-2">
                                        <div className={`custom-input-group ${errors.email ? "is-invalid" : ""}`}>
                                            <span className="custom-input-icon">
                                                <FaEnvelope />
                                            </span>
                                            <Form.Control
                                                placeholder="Email"
                                                name="email"
                                                value={formData.email}
                                                onChange={(e) => handleChange("email", e.target.value)}
                                            />
                                        </div>
                                        {errors.email && (
                                            <div className="invalid-feedback d-block">{errors.email}</div>
                                        )}
                                    </Form.Group>

                                    {/* Requirement Input */}
                                    <Form.Group className="mb-2">
                                        <div className={`custom-input-group ${errors.requirement ? "is-invalid" : ""}`}>
                                            <span className="custom-input-icon">
                                                <FaCommentDots />
                                            </span>
                                            <Form.Control
                                                as="textarea"
                                                rows={1}
                                                placeholder="Requirement"
                                                name="requirement"
                                                value={formData.requirement}
                                                onChange={(e) => {
                                                    handleChange("requirement", e.target.value);

                                                    const textarea = e.target;
                                                    textarea.style.height = "auto";

                                                    const lineHeight = 22;
                                                    const maxHeight = lineHeight * 3;

                                                    textarea.style.height =
                                                        Math.min(textarea.scrollHeight, maxHeight) + "px";
                                                }}
                                                style={{
                                                    resize: "none",
                                                    overflowY: "auto",
                                                    maxHeight: "66px"
                                                }}
                                            />

                                        </div>
                                        {errors.requirement && (
                                            <div className="invalid-feedback d-block">{errors.requirement}</div>
                                        )}
                                    </Form.Group>

                                    {/* City Input */}
                                    <Form.Group className="mb-2">
                                        <div className="custom-input-group">
                                            <span className="custom-input-icon">
                                                <FaMapMarkerAlt />
                                            </span>
                                            <Form.Control
                                                placeholder="City"
                                                name="city"
                                                value={formData.city}
                                                onChange={(e) => handleChange("city", e.target.value)}
                                            />
                                        </div>
                                        {errors.city && (
                                            <div className="invalid-feedback d-block">{errors.city}</div>
                                        )}
                                    </Form.Group>

                                    {/* Business Type Buttons */}
                                    <div className="mb-2">
                                        <label className="form-label fw-semibold mb-2">Business Type</label>
                                        <div className="d-flex flex-wrap gap-2">
                                            {businessTypes.map((type) => (
                                                <Button
                                                    key={type}
                                                    variant={formData.businessType === type ? "primary" : "outline-secondary"}
                                                    onClick={() => handleChange("businessType", type)}
                                                >
                                                    {type}
                                                </Button>
                                            ))}
                                        </div>
                                        {errors.businessType && (
                                            <div className="text-danger mt-1">{errors.businessType}</div>
                                        )}
                                    </div>

                                    {/* Number of Users Buttons */}
                                    <div className="mb-2">
                                        <label className="form-label fw-semibold mb-2">Number of Users</label>
                                        <div className="d-flex flex-wrap gap-2">
                                            {userCounts.map((count) => (
                                                <Button
                                                    key={count}
                                                    variant={formData.usersCount === count ? "primary" : "outline-secondary"}
                                                    onClick={() => handleChange("usersCount", count)}
                                                >
                                                    {count}
                                                </Button>
                                            ))}
                                        </div>
                                        {errors.usersCount && (
                                            <div className="text-danger mt-1">{errors.usersCount}</div>
                                        )}
                                    </div>
                                </Form>
                            )}
                        </div>

                        {/* Sticky Footer */}
                        {!showDemoThankYou && (
                            <div className="demo-fixed-footer">
                                {/* CAPTCHA */}
                                <div className="mb-2">
                                    <label className="form-label fw-semibold mb-1">CAPTCHA</label>
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                        <div className="captcha-box ms-md-2 ms-lg-0">{captchaTexts}</div>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-secondary"
                                            onClick={() => setCaptchaTexts(generateCaptcha())}
                                        >
                                            ↻
                                        </button>
                                    </div>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter CAPTCHA"
                                        value={formData.captchaInput}
                                        onChange={(e) => handleChange("captchaInput", e.target.value)}
                                        isInvalid={!!errors.captchaInput}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.captchaInput}
                                    </Form.Control.Feedback>
                                </div>

                                <button type="submit" className="w-100 pricing-btn" form="demoForm">
                                    BOOK NOW →
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </Modal.Body>
        </Modal >
    );
};

export default BookDemoModal;
